import * as HLF from "html-living-framework";
import * as SFX from "Data/SoundEffect";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { TweenLite } from "gsap";

export class FlyingGameArrowButton extends LayoutButton {
    private _interactive: boolean = true;
    private didPlayHoverVO: boolean = false;

    public get isInteractive() {
        return this._interactive;
    }

    public setInteractive(pInteractive: boolean) {
        this._interactive = pInteractive;
        // intentionally not calling super.setInteractive(pInteractive);
        this.stopPulse();

        if (pInteractive === false) {
            this.disableOutline();
            this.scaleNormal();
        }
        if (this._image) {
            if (pInteractive === false) {
                this.tintDisabled();
            }
            else {
                this.tintEnabled();
            }
        }
        if (this.isOver) {
            this.isOver = false;
        }
    }

    public simulateClick() {
        this.stopPulse();
        super.simulateClick();
        this.playClickedSFX();
    }

    public onFocusActivated() {
        this.stopPulse();
        super.onFocusActivated();
    }

    protected onPointerUp(pEvent: PIXI.InteractionEvent) {
        this.stopPulse();
        super.onPointerUp(pEvent)
    }

    protected playClickedSFX(): void {
        if (this.isInteractive) {
            super.playClickedSFX();
        }
        else {
            PubSub.publishSync(HLF.PLAY_AUDIO, new HLF.AudioToken(SFX.DEAD_CLICK, 1, false, HLF.AudioCategory.SFX));
        }
    }

    protected playHoverVO() {
        if (this.didPlayHoverVO) {
            return;
        }
        HLF.Application.instance.voiceover.playVO(this.hoverVO, {
            priority: -1, mode: HLF.PlayMode.Override, callback: (pDidPlay) => {
                if (pDidPlay) {
                    this.didPlayHoverVO = true;
                }
            }
        });
    }

    protected playKeyboardSelectVO() {
        super.playKeyboardSelectVO();
    }
}